import type {
    QuickFilter,
    UpdateQuickFilterRequest,
    UpdateQuickFilterResponse,
} from "@amzn/ads-blink-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import { getBlinkApiClientV2 } from "../../../../api/blinkApi/blinkApi";
import { useAsyncErrorStatusNotification } from "../../../../hooks/notifications/useAsyncErrorStatusNotification";

export type EditableQuickFilterFields = Omit<
    UpdateQuickFilterRequest,
    "alias" | "identifier"
>;

export function UpdateQuickFilterActionAsync(): [
    AsyncState<UpdateQuickFilterResponse | undefined>,
    UseAsyncActions<
        UpdateQuickFilterResponse,
        [QuickFilter, EditableQuickFilterFields]
    >,
] {
    const [state, action] = useAsync(
        async (
            currentFilter: QuickFilter,
            updatedFields: EditableQuickFilterFields,
        ) => {
            const request: UpdateQuickFilterRequest = {
                alias: currentFilter.alias,
                identifier: currentFilter.identifier,
                ...updatedFields,
            };

            return await (
                await getBlinkApiClientV2()
            ).updateQuickFilter(request);
        },
    );

    // Alert the user of any errors we run into
    useAsyncErrorStatusNotification(state);

    return [state, action];
}
